import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { Category } from './entities/category-entity';
import { SubCategory } from './entities/sub-category-entity';
import { DrrExcel } from './excel-upload/entities/drrexcel.entity';
import { ExcelUploadModule } from './excel-upload/excel-upload.module';
import { configs } from '../../config';
import { RevenueRegisterModule } from './revenue-register/revenue-register.module';
import { ClientConfigurationsModule } from './client-configurations/client-configurations.module';
import { Division } from './client-configurations/entities/division-entity';
import { AuthModule } from './auth/auth.module';
import { PassportModule } from './passport/passport.module';
import { UserModule } from './user/user.module';
import { UserEntity } from './user/user.entity';
import { UserToDivisionEntity } from './user/user-to-division.entity';
import { LedgerExcel } from './excel-upload/entities/ledgerexcel.entity';



@Module({
  imports: [TypeOrmModule.forRoot({
    type: configs.database.type,
    host: configs.database.host,
    port: configs.database.port,
    username: configs.database.username,
    password: configs.database.password,
    database: configs.database.dbName,
    entities: [LedgerExcel, DrrExcel, Category, SubCategory, Division, UserEntity, UserToDivisionEntity],
    synchronize: false,
    logging: true
  }), ExcelUploadModule, RevenueRegisterModule, ClientConfigurationsModule, AuthModule, PassportModule, UserModule],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
